// @ts-ignore
import debug from 'debug';
export default class Logger {
    constructor(namespace) {
        this.fmt = 'yyyy-MM-dd hh:mm:ss';
        this.format = (time, fmt = this.fmt) => {
            const o = {
                'M+': time.getMonth() + 1,
                'd+': time.getDate(),
                'h+': time.getHours(),
                'm+': time.getMinutes(),
                's+': time.getSeconds(),
                'q+': Math.floor((time.getMonth() + 3) / 3),
                S: time.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
                }
            }
            return fmt;
        };
        this._debug = debug(namespace);
        // 默认是关闭的
        this._debug.enabled = true;
        this._debug.log = console.log;
    }
    color(color) {
        this._debug.color = color;
    }
    log(arg1, ...args) {
        try {
            // @ts-ignore
            this._debug(...[arg1, ...args, this.format(new Date())]);
        }
        catch (e) { }
    }
}
